_collow.components.MigrationTool = class MigrationTool extends _collow.components.Base {
  root;
  elements;
  params;

  constructor(root, elements, params) {
    super();
    this.root = root;
    this.elements = elements;
    this.params = params;

    this.elements.submitButton.addEventListener('click', this.handleSubmit.bind(this));
    this.elements.inputField.addEventListener('change', this.validateFileSize.bind(this));
  }

  validateFileSize(event) {
    const maxSizeMB = 4.5;
    const file = event.target.files[0];

    if (file && file.size > maxSizeMB * 1024 * 1024) {
      _collow.Notify.error(`${this.params.messageFileSizeToBig} ${maxSizeMB} MB.`);
      event.target.value = '';
    }
  }

  valueSlide = () => {
    const creativityLabels = {
      1: 'notCreative',
      2: 'lowCreative',
      3: 'mediumCreative',
      4: 'highCreative',
      5: 'maxCreative',
    }
    
    const sliderValue = this.elements.slider.value;
    return creativityLabels[sliderValue]; // Return the mapped value
  }
  
  handleSubmit() {
    // 1. Get the slider value by calling the updated valueSlide method
    const creativityValue = this.valueSlide();

    // --- File check remains the same ---
    if (!this.elements.inputField.files.length) {
      _collow.Notify.error('Please select a file');
      return;
    }

    const file = this.elements.inputField.files[0];
    const formData = new FormData();

    // 2. Append the file (as before)
    formData.append("pdf_file", file);

    // 3. Append the slider value
    // Use a meaningful key for the API, e.g., "creativityLevel"
    formData.append("creativityLevel", creativityValue);

    // 4. Append the state of the checkboxes
    // Assuming 'this.elements.quizCheckbox' and 'this.elements.imageCheckbox'
    // refer to your checkbox input elements based on their data attributes.
    // The '.checked' property returns true if checked, false otherwise.
    formData.append("includeQuiz", this.elements.quizCheckbox.checked);
    formData.append("includeImages", this.elements.imageCheckbox.checked);

    // --- UI updates and Fetch call remain the same ---
    this.elements.submitButton.classList.add('disabled');
    this.elements.submitButton.innerHTML = 'Loading..';
    const infoToast = _collow.Notify.info('Starting the migration process, please wait..', { duration: 5000 });

    fetch(this.params.apiPath + "/eduai/migrate_content", {
      method: "POST",
      headers: {
        Authorization: localStorage.getItem("token"),
        // Content-Type is set automatically by the browser for FormData
      },
      body: formData, // This formData now contains the file AND the extra data
    })
    .then((res) => {
      infoToast.remove();
      if (res.status === 200) {
        _collow.Notify.success('The migration proccess has been started..');
        return;
      }
      _collow.Notify.error('Something went wrong, please try again.');
    })
    .catch((err) => {
      _collow.Notify.error('Something went wrong, please try again.');
      console.log(err);
    })
    .finally(() => {
      this.elements.submitButton.classList.remove('disabled');
      // Consider setting the button text back to the original dynamic value if needed
      this.elements.submitButton.innerHTML = 'Send';
    });
  }
}